import AgentApiToken from "../../Api/Services/AppflyteBackend/AgentApiToken";


export const getProjectAgentApiTokens = async (organization_id, project_id) => {
    const tempArr = []
    let last_evaluated_key = null
    try {
        do {
            const response = await AgentApiToken.getProjectTokens(last_evaluated_key, organization_id, project_id);
            if (response.data) {
                const collectionData = response.data.published_collections_detail.flatMap(collection => response.data[collection.id]);
                if (collectionData) {
                    tempArr.push(...collectionData)
                }
            }
            last_evaluated_key = response.data.last_evaluated_key != null && response.data.last_evaluated_key !== "" ? encodeURIComponent(JSON.stringify(response.data.last_evaluated_key)) : null
        }
        while (last_evaluated_key !== null)
        return tempArr;
    }
    catch (error) {
        console.error(error)
    }
}


export const getOrganizationAgentApiTokens = async (organization_id) => {
    const tempArr = []
    let last_evaluated_key = null
    try {
        do {
            const response = await AgentApiToken.getOrgTokens(last_evaluated_key, organization_id);
            if (response.data) {
                const collectionData = response.data.published_collections_detail.flatMap(collection => response.data[collection.id]);
                if (collectionData) {
                    tempArr.push(...collectionData)
                }
            }
            last_evaluated_key = response.data.last_evaluated_key != null && response.data.last_evaluated_key !== "" ? encodeURIComponent(JSON.stringify(response.data.last_evaluated_key)) : null
        }
        while (last_evaluated_key !== null)
        return tempArr;
    }
    catch (error) {
        console.error(error)
    }
}

